// extracted by mini-css-extract-plugin
export default {"container":"empty-message_container__VG4ct"};